import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  MainContainer,
  PageTitle,
  HeaderLink,
  NavIcon,
} from './profile-settings.style';
import OfficePreferences from '../../core/common/office-preferences';
import navIcon from '../../../assets/icon-nav-arrow.svg';

/**
 * Profile Settings container component. User is able to set what
 * offices they are a part of in this container.
 * @return {element} - Profile settings component
 */
const ProfileSettings = () => {
  const history = useHistory();

  /**
   * Handles when a user clicks the back
   * button
   * @return {void} - This function does not return anything
   */
  const handleGoBack = () => {
    history.push('/');
  };

  return (
    <MainContainer>
      <HeaderLink onClick={handleGoBack}>
        <NavIcon src={navIcon} />
        Back to Tracking Queue
      </HeaderLink>
      <PageTitle>
        Profile Settings
      </PageTitle>
      <OfficePreferences
        title="Office Preferences: "
        description="Select which office’s loads to show in your Tracking Queue. You must select at least one office."
        isModal={false}
      />
    </MainContainer>
  );
};

export default ProfileSettings;
